export default __webpack_public_path__ + "static/media/WorkSans-Light.aee43a35.woff";